import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';
import { getMemberId } from '@/users/membership/helper';
import useDebounce from '@/utils/debounce';
import MembersPermissionAddRow from '@/users/membership/components/MembersPermissionAddRow';
import {
  addCollectionMembers, fetchCollectionMembers, updateCollectionMembersProperties, updateShareCollectionProperties,
} from '../actions';
import { collectionPermissionGroups } from '../constants';

const CollectionMemberAddRow = ({
  category,
  code,
  members,
  membersToAdd,
  fetchData,
  updateFilter,
  updateProperties,
  addMembers,
  readStatus,
  filter,
  permission,
  allowSecure,
}) => {
  const debouncedFetch = useDebounce(fetchData);

  const onFilterChange = useCallback((value) => {
    updateFilter(category, code, value);
    debouncedFetch(category, code, value);
  }, [category, code, updateFilter, debouncedFetch]);

  return (
    <MembersPermissionAddRow
      addMembers={() => addMembers(category, code)}
      allowSecure={allowSecure}
      entity="collection"
      filter={filter}
      members={members}
      membersToAdd={membersToAdd}
      onFilterChange={onFilterChange}
      permission={permission}
      permissionGroups={collectionPermissionGroups}
      readStatus={readStatus}
      updateProperties={updateProperties}
    />
  );
};

const dialogProps = (sharingCollection, members = []) => (
  {
    permission: sharingCollection.permissionGroup,
    membersToAdd: sharingCollection.membersToAdd,
    members: sharingCollection.membersToAdd.concat(members),
  }
);

const withoutItem = (sharingCollection) => (
  {
    ...dialogProps(sharingCollection),
    ...readStates,
    filter: '',
  }
);

const withItem = (item, sharingCollection) => {
  const members = item.members.results;
  const assignable = item.unassignedMembers.results;
  const memberIds = members.map(getMemberId);

  return (
    {
      ...dialogProps(sharingCollection, assignable.filter((member) => (!memberIds.includes(getMemberId(member))))),
      readStatus: item.unassignedMembers.readStatus,
      readErrors: item.unassignedMembers.readErrors,
      filter: item.unassignedMembers.filter,
    }
  );
};

const mapStateToProps = ({
  collections: {
    collections,
    sharingCollection,
  },
}, { category, code }) => {
  const item = findResult(collections, category, code);
  return item ? withItem(item, sharingCollection) : withoutItem(sharingCollection);
};

const mapDispatchToProps = {
  addMembers: addCollectionMembers,
  fetchData: (category, code, filter) => fetchCollectionMembers(category, code, true, filter),
  updateFilter: (category, code, filter) => updateCollectionMembersProperties(category, code, true, { filter }),
  updateProperties: updateShareCollectionProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionMemberAddRow);
